import axios from 'axios';
import { baseURL } from '../../../base-url.js';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('jwt')}`
});

export default {
  async loadSchedules({ commit }, { salonId, date }) {
    try {
      const response = await axios.get(`${baseURL}/taskSchedule/getSchedules`, {
        params: { salonId, date },
        headers: getAuthHeaders()
      });

      commit('setSchedules', response.data);
      return response;
    } catch (error) {
      commit('setSchedules', []);
      throw error.response || error;
    }
  },

  async updateSchedule({ commit }, { schedule, status, note }) {
    const nextStatus = status ?? schedule.status;
    const nextNote = note === undefined ? schedule.note : note;
    const payload = {
      taskScheduleId: schedule.id,
      note: nextNote?.trim() || null,
      taskId: schedule.taskId,
      employeeId: schedule.employeeId,
      salonId: schedule.salonId,
      tenantId: schedule.tenantId,
      date: schedule.date,
      status: nextStatus
    };

    try {
      const response = await axios.put(`${baseURL}/taskSchedule/updateSchedule`, payload, {
        headers: getAuthHeaders()
      });

      commit('replaceSchedule', {
        id: schedule.id,
        schedule: {
          ...schedule.raw,
          ...response.data,
          note: payload.note,
          status: nextStatus
        }
      });

      return response;
    } catch (error) {
      throw error.response || error;
    }
  },

  async loadWeekSchedules({ commit }, { salonId, startDate, endDate }) {
    try {
      const response = await axios.get(`${baseURL}/taskSchedule/getSchedulesByDateRange`, {
        params: { salonId, startDate, endDate },
        headers: getAuthHeaders()
      });
      const schedules = Array.isArray(response.data) ? response.data : [];
      commit('setSchedules', schedules);
      return schedules;
    } catch (error) {
      commit('setSchedules', []);
      throw error.response || error;
    }
  },

  async updateSchedules(_, schedules) {
    try {
      return await axios.put(`${baseURL}/taskSchedule/updateSchedules`, { schedules }, {
        headers: getAuthHeaders()
      });
    } catch (error) {
      throw error.response || error;
    }
  },

  async scheduleWeek(_, salonId) {
    try {
      return await axios.post(`${baseURL}/taskSchedule/schedule-week`, null, {
        params: { salonId },
        headers: getAuthHeaders()
      });
    } catch (error) {
      throw error.response || error;
    }
  },

  async loadTasks({ commit }) {
    try {
      const response = await axios.get(`${baseURL}/task/getAllTasks`, {
        headers: getAuthHeaders()
      });
      commit('setTasks', response.data);
      return response.data;
    } catch (error) {
      commit('setTasks', []);
      throw error.response || error;
    }
  },

  async createTask(_, payload) {
    try {
      return await axios.post(`${baseURL}/task/createTask`, payload, {
        headers: getAuthHeaders()
      });
    } catch (error) {
      throw error.response || error;
    }
  },

  async deleteTask(_, taskId) {
    try {
      return await axios.delete(`${baseURL}/task/deleteTask`, {
        params: { id: taskId },
        headers: getAuthHeaders()
      });
    } catch (error) {
      throw error.response || error;
    }
  }
};
